<template>
	<div>
		<el-dialog :title="$t('DataRecycling.ExportImageSettingsField')" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
			<div class="imgFieldBox">
				<div class="left">
					<div @click="activeField(item)" class="leftField" v-for="item in allList" :key="item.enfieldName">{{ item.chfieldName }}</div>
				</div>
				<div class="right">
					<div :class="textareaType == 1 ? 'rightActive' : 'rightTop'">
						<span>{{$t('DataRecycling.Route')}}：</span>
						<div class="textarea"><el-input type="textarea" :rows="5" :placeholder="$t('DataRecycling.PleaseEnterContent')" v-model="fieldPathText" @focus="focusOne"></el-input></div>
					</div>
					<div :class="textareaType == 2 ? 'rightActive' : 'rightBom'">
						<span>{{$t('DataRecycling.Name')}}：</span>
						<div class="textarea"><el-input type="textarea" :rows="5" :placeholder="$t('DataRecycling.PleaseEnterContent')" v-model="fieldNameText" @focus="focusTwo"></el-input></div>
					</div>
					<div class="rightBomText">{{$t('DataRecycling.LabelTip')}}</div>

					<div class="rightBom">
						<span>{{$t('DataRecycling.State')}}：</span>
						<div>
							<el-radio v-model="answerState" label="1">{{$t('DataRecycling.AllImages')}}</el-radio>
							<el-radio v-model="answerState" label="6">{{$t('DataRecycling.CompleteImage')}}</el-radio>
							<el-radio v-model="answerState" label="4">{{$t('DataRecycling.IdentifyingImages')}}</el-radio>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" :loading="loading" :disabled="loading" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" :loading="loading" :disabled="loading" @click="exportImgOk">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			answerState: '1',
			surveyId: '',
			fieldPathText: '',
			fieldPath: '',
			fieldNameText: '',
			fieldName: '',
			dialogVisible: false,
			textareaType: 1,
			allList: []
		};
	},
	methods: {
		exportImgOk() {
			this.loading = true;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.downloadAnswerPhoto}`,
				method: 'POST',
				data: {
					surveyId: this.surveyId,
					fileName: this.fieldName,
					filePath: this.fieldPath,
					answerState: this.answerState,
					source: 'mf'
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.popUpPrompt()
						that.dialogVisible = false
						that.loading = false;
					} else {
						that.$message.error(res.message);
						that.loading = false;
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		activeField(data) {
			console.log(data);
			if (this.textareaType == 1) {
				this.fieldPathText = this.fieldPathText + '[' + data.chfieldName + ']';
				this.fieldPath = this.fieldPath + '[' + data.enfieldName + ']';
			} else {
				this.fieldNameText = this.fieldNameText + '[' + data.chfieldName + ']';
				this.fieldName = this.fieldName + '[' + data.enfieldName + ']';
			}
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.surveyId
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.allList = res.resultBody.questionsFieldMappings;
						console.log(that.allList);
					} else {
						that.allList = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		openExportimg() {
			this.surveyId = sessionStorage.getItem('wid');
			this.loadData();
			this.answerState = '1';
			this.fieldPathText = '';
			this.fieldPath = '';
			this.fieldNameText = '';
			this.fieldName = '';
			this.textareaType='1'
			this.dialogVisible = true;
		},
		focusOne() {
			this.textareaType = 1;
		},
		focusTwo() {
			this.textareaType = 2;
		}
	}
};
</script>

<style lang="scss" scoped>
.imgFieldBox {
	height: 100%;
	padding: 20px;
	box-sizing: border-box;
	display: flex;
	.left {
		width: 300px;
		max-height: 500px;
		margin-right: 20px;
		border: 1px solid #ccc;
		border-radius: 4px;
		height: 100%;
		padding: 20px;
		overflow: auto;
		.leftField {
			padding: 10px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.leftField:hover {
			color: #fff;
			background: #1890ff;
		}
	}
	.right {
		flex: 1;
		padding: 20px;
		border: 1px solid #ccc;
		border-radius: 4px;
		overflow: auto;
		.rightTop {
			display: flex;
			align-items: center;
			padding: 20px;
			.textarea {
				flex: 1;
			}
		}
		.rightBom {
			display: flex;
			align-items: center;
			padding: 20px;
			.textarea {
				flex: 1;
			}
		}
		.rightBomText {
			color: #c1c1c1;
		}
		.rightActive {
			border: 1px solid #0080ff;
			display: flex;
			align-items: center;
			padding: 20px;
			.textarea {
				flex: 1;
			}
		}
	}
}
</style>
